import {
  VISUALIZER_AUDIO_LEVEL_HEIGHT_SCALE,
  VISUALIZER_BAR_COUNT,
  VISUALIZER_BAR_MAX_HEIGHT,
  VISUALIZER_BAR_MIN_HEIGHT,
  VISUALIZER_MAX_AUDIO_LEVEL,
  VISUALIZER_RANDOM_HEIGHT_VARIATION,
  VISUALIZER_WAVE_AMPLITUDE,
  VISUALIZER_WAVE_INDEX_OFFSET,
  VISUALIZER_WAVE_TIME_DIVISOR,
} from '../config';

export const computeVisualizerBars = (
  audioLevel: number,
  timestamp: number,
): number[] =>
  Array(VISUALIZER_BAR_COUNT)
    .fill(0)
    .map((_, index) => {
      const waveOffset =
        Math.sin(
          timestamp / VISUALIZER_WAVE_TIME_DIVISOR +
            index * VISUALIZER_WAVE_INDEX_OFFSET,
        ) * VISUALIZER_WAVE_AMPLITUDE;
      const baseHeight =
        (audioLevel / VISUALIZER_MAX_AUDIO_LEVEL) *
        VISUALIZER_AUDIO_LEVEL_HEIGHT_SCALE;
      const variation = Math.random() * VISUALIZER_RANDOM_HEIGHT_VARIATION;
      const height = Math.max(
        VISUALIZER_BAR_MIN_HEIGHT,
        baseHeight + baseHeight * waveOffset + variation,
      );

      return Math.min(VISUALIZER_BAR_MAX_HEIGHT, height);
    });
